module.exports = __webpack_public_path__ + "img/google-play-en.bc2b89a1.png";